module.exports = JSON.parse('{"languageSwitcher":{"label":"Забон"},"close":"Пӯшидан","pageTitle":"Соли нав 2027 — Ҳеҷ зиёдатӣ! | NL International"}')